(function ($, njm) {
    'use strict';

    njm.views.microHeroSlider = Backbone.View.extend({

        events: {
            'click .slider': 'onSliderClick'
        },

        /**
         * On slider click
         * @param ev
         */
        onSliderClick: function (ev) {
            ev.preventDefault();

            var $slider = $(ev.currentTarget);
            var $hero = this.$el;
            var direction = $slider.attr('data-direction');
            var target = $slider.attr('data-block');
            var current = $hero.attr('data-position');

            if (direction === 'left') {
                this.translateX($hero.find('.' + target), '-100%');
            } else {
                this.translateX($hero.find('.' + target), '100%');
            }

            setTimeout(function () {
                this.transition($hero.find('.' + target), '1000');
                this.transition($hero.find('.' + current), '1000');

                if (direction === 'left') {
                    this.translateX($hero.find('.' + current), '100%');
                } else {
                    this.translateX($hero.find('.' + current), '-100%');
                }

                $hero.attr('data-position', target);
                $('.comp-micro-about').attr('data-position', target);
            }.bind(this), 150);
        },

        /**
         * Transition
         * @param target
         * @param time
         */
        transition: function (target, time) {
            $(target).css({ transitionDuration: time + 'ms' });
            setTimeout(function () {
                $(target).css({ transitionDuration: '0ms' });
            }, time);
        },

        /**
         * TranslateX
         * @param target
         * @param value
         */
        translateX: function (target, value) {
            $(target).css({ transform: 'translateX(' + value + ')' });
        }
    });
})(jQuery, njm);
